import { createSelector } from '@reduxjs/toolkit';
import { BootstrapConfig, CmsValue } from 'core/type/BootstrapConfig.types';
import { FooterBehavior } from 'core/type/behaviors.types';
import { selectCmsFromBootstrap, selectConfigFromBootstrap, selectFooterBehavior } from 'store/slice/bootstrap';
import { selectTextSearchOverlayVisible } from 'store/slice/overlay';

interface StateProps {
    footer: FooterBehavior;
    cms: CmsValue;
    config: BootstrapConfig;
    textSearchOverlayVisible: boolean;
}

export type ActivitiesFooterProps = StateProps;

export const mapStateToProps = createSelector(
    selectFooterBehavior,
    selectCmsFromBootstrap,
    selectConfigFromBootstrap,
    selectTextSearchOverlayVisible,
    (footer, cms, config, textSearchOverlayVisible): StateProps => {
        return {
            footer,
            cms,
            config,
            textSearchOverlayVisible,
        };
    },
);
